const teachingSubjects = [
  {
    category: "Elementary Education",
    order: 2,
    subjects: [{ description: "Elementary Education", value: 0x800 }]
  },
  {
    category: "Special Education",
    order: 5,
    subjects: [{ description: "Special Education", value: 0x1000 }]
  },
  {
    category: "STEM",
    order: 6,
    subjects: [
      { description: "Mathematics", value: 0x10 },
      { description: "Science", value: 0x2000 },
      { description: "Engineering", value: 0x4000 },
      { description: "Technology", value: 0x8000 }
    ]
  },
  {
    category: "Humanities",
    order: 4,
    subjects: [
      { description: "Social Studies", value: 0x80 },
      { description: "Fine Art", value: 0x20 },
      { description: "World Language", value: 0x10000 },
      { description: "English Language Arts", value: 0x100 },
      { description: "PE (Phys. Ed.)", value: 0x200000 }
    ]
  },
  {
    category: "CTE",
    order: 1,
    subjects: [
      { description: "CTE Courses", value: 0x200 },
      { description: "Medical Education", value: 0x40 },
      { description: "College Courses", value: 0x400 }
    ]
  },
  {
    category: "Other",
    order: 7,
    subjects: [
      { description: "Culture/Diversity", value: 0x40000 },
      { description: "Student Retention", value: 0x80000 },
      { description: "English Language Learners", value: 0x20000 },
      { description: "Librarian", value: 0x400000 },
      { description: "Social and Emotional Learning", value: 0x800000 },
      { description: "Public Health", value: 0x1000000 }
    ]
  },
  {
    category: "Foundation",
    order: 3,
    subjects: [
      { description: "Homeless", value: 0x1 },
      { description: "At Risk", value: 0x2 },
      { description: "Welfare", value: 0x4 },
      { description: "Food Insecurity", value: 0x8 }
    ]
  }
];

export { teachingSubjects };
